import { z } from 'zod';

import type { UsedNoteType } from '../types/notes';

import { usedNoteTypes } from '../config/notes';
import { nonEmptyString } from './data';

export const noteTextSchema = z.string().min(3);

export const newNoteTypeSchema = z.enum([
  'PAR',
  'PRO',
  'RAC',
  'TCY',
] as const satisfies UsedNoteType[]);

/** Source of truth for the `notes` user store table (see userStoreSchema.ts) */
export const noteSchema = z.object({
  noteId: z.string(),
  propertyId: z.number(),
  /**
   * Used to link a note to an associated entity i.e. personId, propertyRef etc.
   * The value used corresponds with the parameter required for Notepad API calls
   * e.g. `/Property/{URI_PROPREF}/Notepad` (see notes.sql).
   * Numeric IDs are stringified for type consistency
   * */
  entityRef: nonEmptyString,
  type: z.enum(usedNoteTypes),
  subtype: z.string().optional(),
  subject: nonEmptyString,
  note: nonEmptyString,
  caution: z.boolean(),
  createdBy: nonEmptyString,
  created: nonEmptyString,
});

/** Source of truth for the `fireSafetyNotes` user store table (see userStoreSchema.ts) */
export const fireSafetyNoteSchema = z.object({
  noteId: z.string(),
  propertyId: z.number(),
  personId: z.number(),
  note: noteTextSchema,
  createdBy: nonEmptyString,
  created: nonEmptyString,
});

export const newNoteSchema = noteSchema.extend({
  type: newNoteTypeSchema,
  note: noteTextSchema,
});
